<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle">
        <div class="div_loading">
            <div class="my-container" [hidden]="!loading">
                <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
            </div>
        </div>
        گالری تیپ ها
        <span class="close">
            <mat-icon (click)="close()">close</mat-icon>
        </span>
    </div>
</div>


<div mat-dialog-content class="matDialogContent">
    <p class="p1">عکس ورودی <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 7 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 7">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">
                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>

            </div>
        </span>

    </form><!-- dropzone dz-started -->

    <p class="p1"> شیت معماری <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 1 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 1">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">

                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>
            </div>
        </span>
    </form><!-- dropzone dz-started -->


    <p class="p1">نمای خارجی <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 2 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 2">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">
                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>
            </div>
        </span>
    </form><!-- dropzone dz-started -->

    <p class="p1">سازه <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 3 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 3">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">
                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>
            </div>
        </span>
    </form><!-- dropzone dz-started -->

    <p class="p1">پلان طبقات <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 6 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 6">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">
                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>
            </div>
        </span>
    </form><!-- dropzone dz-started -->







    <p class="p1">3D <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 4 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 4">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">
                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>
            </div>
        </span>
    </form><!-- dropzone dz-started -->


    <p class="p1">گالری عکس ها - روبروی تب ها <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 5 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 5">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">
                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>
            </div>
        </span>
    </form><!-- dropzone dz-started -->



    <p class="p1"> جزئیات فنی <span (click)="get_data(2)"><i class="fas fa-cogs icon"></i></span></p>
    <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
        <input type="" name="code" value="{{ id }}" style="display:none">
        <input type="" name="username" value="{{ username }}" style="display:none">
        <input type="" name="type" value="{{ 5 }}" style="display:none">
        <input type="" name="cate" value="{{ 8 }}" style="display:none">
        <input type="" name="site" value="{{ site }}" style="display:none">
        <span *ngFor="let file of list_data;let i = index">
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                *ngIf="file.tip_attach_cate == 8">
                <div class="dz-image">
                    <a href='{{ file.tip_attach_site }}/{{ file.tip_attach_name }}' target="_blank">
                        <span
                            *ngIf="file.tip_attach_type == 'image/jpeg' || file.tip_attach_type == 'image/gif' ||  file.tip_attach_type == 'image/png' ">
                            <img data-dz-thumbnail="" src="{{ file.tip_attach_site }}/{{ file.tip_attach_name  }}">
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/msword' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                            <i class="far fa-file-word icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'application/vnd.ms-excel' || file.tip_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                            <i class="fas fa-file-excel icone" style='color:green'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/pdf' ">
                            <i class="far fa-file-pdf icone" style='color:red'></i>
                        </span>
                        <span *ngIf="file.tip_attach_type == 'application/zip' ">
                            <i class="fas fa-file-archive icone"></i>
                        </span>
                        <span
                            *ngIf="file.tip_attach_type == 'video/mp4' || file.tip_attach_type == 'video/x-matroska';else other ">
                            <i class="fas fa-file-video icone" style='color:black'></i>
                        </span>
                        <ng-template #other>
                            <i class="fas fa-file-alt icone" style='color:black'></i>
                        </ng-template>
                    </a>
                </div><!-- dz-image -->
                <div class="dz-details">
                    <div class="dz-size">
                    </div><!-- dz-size-->
                    <div class="dz-filename">
                    </div><!-- dz-filename-->
                </div> <!-- dz-detaile-->
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                </div><!-- dz-progress -->
                <div class="dz-error-message">
                    <span data-dz-errormessage=""></span>
                </div><!-- dz-error-message -->
                <span class="material-icons icon" style="font-size:1.2rem"
                    (click)="delete(i,file.tip_attach_id)">delete_forever</span>
            </div>
        </span>
    </form><!-- dropzone dz-started -->

</div>